export const isEqlFieldCommon = (field: string) => {
  return (
    field.startsWith('metadata.global') || field.startsWith('metadata.common')
  );
};
